import Tooltip from '@atlaskit/tooltip';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { useSignUpFormUIState } from '../../../../../hook';
import { messages } from '../../../../../messages';
import { TooltipDialog } from './styled';

export function EulaComponent() {
  const { isBeacon } = useSignUpFormUIState();
  if (isBeacon) {
    return (
      <p className="eula-compass">
        <SanitizedFormattedHtmlMessage {...messages.eulaCompass} />
        <Tooltip
          component={TooltipDialog}
          content={
            <SanitizedFormattedHtmlMessage {...messages.eulaCompassTooltip} />
          }
        >
          <span className="tooltip">&nbsp;ⓘ</span>
        </Tooltip>
      </p>
    );
  }

  return <SanitizedFormattedHtmlMessage {...messages.eula} />;
}
